import { render, staticRenderFns } from "./TiYouYou.vue?vue&type=template&id=783da5b4&"
import script from "./TiYouYou.vue?vue&type=script&lang=js&"
export * from "./TiYouYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports